import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
];

const NavLinks = () => {
  const location = useLocation();
  return (
    <div className="flex items-center gap-8">
      {navLinks.map((link) => (
        <Link
          key={link.path}
          to={link.path}
          data-testid={`nav-link-${link.name.toLowerCase()}`}
          className={`text-sm font-medium uppercase tracking-widest transition-colors ${
            location.pathname === link.path ? 'text-pink-mauve' : 'text-brown-warm hover:text-pink-mauve'
          }`}
        >
          {link.name}
        </Link>
      ))}
    </div>
  );
};

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/90 backdrop-blur-md border-b border-pink-blush shadow-soft' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          <Link
            to="/"
            className="text-xl md:text-2xl font-serif font-semibold text-brown-deep hover:text-pink-mauve transition-colors"
            data-testid="nav-logo"
          >
            Zara Miller
          </Link>
          <NavLinks />
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;
